import type { TrainerCapability } from '@zeus/index'
import type { Dependencies, Grants } from '~/pages/backoffice/admin/trainer-capabilities/capability-grants'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'

type IProps = {
  title: string
  capabilities: TrainerCapability[]
  grants: Grants
  dependencies: Dependencies
  onToggle: (capability: TrainerCapability, granted: boolean) => void
}

/** Les capacités d'un domaine (parcours, modules…), chacune avec ce qu'elle suppose. */
function CapabilityDomain({ title, capabilities, grants, dependencies, onToggle }: IProps) {
  const { t } = useTranslation()
  const titleId = useId()

  return (
    <Card>
      <CardHeader>
        <CardTitle id={titleId}>{title}</CardTitle>
      </CardHeader>
      {/* Chaque case dit son domaine (« Parcours », « Modules »…) au lecteur d'écran (RGAA 11.5). */}
      <CardContent role="group" aria-labelledby={titleId} className="flex flex-col gap-3">
        {capabilities.map((capability) => {
          const requires = dependencies[capability] ?? []
          return (
            <label key={capability} className="flex cursor-pointer items-start gap-2 text-sm">
              <input
                type="checkbox"
                className="mt-0.5"
                checked={grants[capability] ?? false}
                onChange={e => onToggle(capability, e.target.checked)}
              />
              <span className="flex flex-col gap-0.5">
                {t(`trainerCapabilities.cap.${capability}`)}
                {requires.length > 0 && (
                  <span className="text-xs text-muted-foreground">
                    {t('trainerCapabilities.requires', {
                      list: requires.map(required => t(`trainerCapabilities.cap.${required}`)).join(', '),
                    })}
                  </span>
                )}
              </span>
            </label>
          )
        })}
      </CardContent>
    </Card>
  )
}

export default CapabilityDomain
